module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addLabels
    }
  }, [_vm._v("添加账号")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.mobile),
      callback: function($$v) {
        _vm.mobile = $$v
      },
      expression: "mobile"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.dataSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.accountsList,
      "height": _vm.wheight - 160
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "login_name",
      "label": "账号名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "姓名"
    }
  }), _vm._v(" "), (_vm.login_type == 'distributor') ? _c('el-table-column', {
    attrs: {
      "prop": "roles",
      "label": "角色"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.role_data), function(item) {
          return _c('el-tag', {
            key: item.role_id,
            attrs: {
              "size": "mini",
              "type": "warning"
            }
          }, [_vm._v(" " + _vm._s(item.role_name) + " ")])
        })
      }
    }], null, false, 186645409)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.editAction(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.deleteAccountAction(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editTitle,
      "visible": _vm.editVisible,
      "before-close": _vm.handleCancel
    },
    on: {
      "update:visible": function($event) {
        _vm.editVisible = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.form,
        "label-width": "120px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "登录账号"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 10
      }
    }, [(!_vm.editLoginName) ? _c('el-input', {
      attrs: {
        "minlength": 4,
        "maxlength": 16,
        "placeholder": "请输入员工登录账号"
      },
      model: {
        value: (_vm.form.login_name),
        callback: function($$v) {
          _vm.$set(_vm.form, "login_name", $$v)
        },
        expression: "form.login_name"
      }
    }) : _c('el-input', {
      attrs: {
        "disabled": true
      },
      model: {
        value: (_vm.form.login_name),
        callback: function($$v) {
          _vm.$set(_vm.form, "login_name", $$v)
        },
        expression: "form.login_name"
      }
    })], 1), _vm._v(" "), _c('p', {
      staticClass: "frm-tips"
    }, [_vm._v("账号名称4-16位，名称使用字母开头，字符有有字母，数字，下划线")])], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "手机号"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 10
      }
    }, [(!_vm.isEdit) ? _c('el-input', {
      attrs: {
        "maxlength": 11,
        "placeholder": "请输入11位手机号"
      },
      model: {
        value: (_vm.form.mobile),
        callback: function($$v) {
          _vm.$set(_vm.form, "mobile", $$v)
        },
        expression: "form.mobile"
      }
    }) : _c('el-input', {
      attrs: {
        "disabled": true
      },
      model: {
        value: (_vm.editMobile),
        callback: function($$v) {
          _vm.editMobile = $$v
        },
        expression: "editMobile"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "姓名"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 10
      }
    }, [_c('el-input', {
      attrs: {
        "required": "",
        "placeholder": "请填写昵称"
      },
      model: {
        value: (_vm.form.username),
        callback: function($$v) {
          _vm.$set(_vm.form, "username", $$v)
        },
        expression: "form.username"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "登录密码"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 10
      }
    }, [_c('el-input', {
      attrs: {
        "maxlength": 255
      },
      model: {
        value: (_vm.form.password),
        callback: function($$v) {
          _vm.$set(_vm.form, "password", $$v)
        },
        expression: "form.password"
      }
    })], 1)], 1), _vm._v(" "), (_vm.login_type == 'default') ? _c('el-form-item', {
      attrs: {
        "label": "所属店铺"
      }
    }, [_vm._l((_vm.relDistributors), function(item, index) {
      return _c('el-tag', {
        key: item.distributor_id,
        staticClass: "new-tag",
        attrs: {
          "closable": "",
          "disable-transitions": false
        },
        on: {
          "close": function($event) {
            return _vm.DistributoreHandleClose(index)
          }
        }
      }, [_vm._v(" " + _vm._s(item.name) + "\n            ")])
    }), _vm._v(" "), _c('el-button', {
      staticClass: "button-new-tag",
      attrs: {
        "size": "medium"
      },
      on: {
        "click": _vm.addDistributoreAction
      }
    }, [_vm._v("+ 点击搜索店铺 ")])], 2) : _vm._e(), _vm._v(" "), (_vm.login_type == 'distributor') ? _c('el-form-item', {
      attrs: {
        "label": "角色"
      }
    }, [_c('el-checkbox-group', {
      model: {
        value: (_vm.form.role_id),
        callback: function($$v) {
          _vm.$set(_vm.form, "role_id", $$v)
        },
        expression: "form.role_id"
      }
    }, _vm._l((_vm.rolesListData), function(role) {
      return _c('el-checkbox', {
        key: role.role_id,
        attrs: {
          "label": role.role_id,
          "value": role.role_id
        }
      }, [_vm._v(_vm._s(role.role_name))])
    }), 1)], 1) : _vm._e()], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          return _vm.handleCancel.apply(null, arguments)
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.submitAction
      }
    }, [_vm._v("保存")])], 1)
  ], 2), _vm._v(" "), _c('DistributorSelect', {
    attrs: {
      "store-visible": _vm.DistributorVisible,
      "is-valid": _vm.isValid,
      "rel-data-ids": _vm.relDistributors,
      "get-status": _vm.DistributorStatus
    },
    on: {
      "chooseStore": _vm.DistributorChooseAction,
      "closeStoreDialog": _vm.closeDialogAction
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7e89ca5c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e89ca5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/account/storestaff.vue
// module id = 2859
// module chunks = 0